import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlug = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7 11.5V15.3481C7 16.2449 7.67791 16.9965 8.56993 17.0888L14.6252 17.7152L15.6312 18.8889C15.9637 19.2768 16.4491 19.5 16.9599 19.5H18.25C19.2165 19.5 20 18.7165 20 17.75V15.5H23.25C23.6642 15.5 24 15.1642 24 14.75C24 14.3358 23.6642 14 23.25 14H20V7.5H23.25C23.6642 7.5 24 7.16421 24 6.75C24 6.33579 23.6642 6 23.25 6H20V3.75C20 2.7835 19.2165 2 18.25 2H16.9599C16.4491 2 15.9637 2.22323 15.6312 2.61112L14.6253 3.78476L8.56993 4.41118C7.67791 4.50346 7 5.25511 7 6.15189V10H2.9375C1.31516 10 0 11.3152 0 12.9375V21.25C0 21.6642 0.335786 22 0.75 22C1.16421 22 1.5 21.6642 1.5 21.25V12.9375C1.5 12.1436 2.14359 11.5 2.9375 11.5H7ZM16.7701 3.5873C16.8176 3.53189 16.887 3.5 16.9599 3.5H18.25C18.3881 3.5 18.5 3.61193 18.5 3.75V17.75C18.5 17.8881 18.3881 18 18.25 18H16.9599C16.887 18 16.8176 17.9681 16.7701 17.9127L15.5694 16.5119C15.4444 16.3661 15.2682 16.2737 15.0772 16.254L8.72427 15.5968C8.59684 15.5836 8.5 15.4762 8.5 15.3481V6.15189C8.5 6.02378 8.59684 5.9164 8.72428 5.90322L15.0772 5.24602C15.2682 5.22625 15.4444 5.13393 15.5694 4.98809L16.7701 3.5873Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgPlug;
